import React, { PureComponent } from "react";

class TTPArticleWidget extends PureComponent {
  constructor(props) {
    super(props);
    this.widgetRef = React.createRef();
  }

  componentDidMount() {
    if (window.TTPWidget !== undefined) {
      window.TTPWidget.mount(this.props, this.widgetRef.current);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (window.TTPWidget !== undefined) {
        window.TTPWidget.mount(this.props, this.widgetRef.current);
      }
    }
  }

  componentWillUnmount() {
    if (window.TTPWidget) {
      window.TTPWidget.unmount(this.widgetRef.current);
    }
  }

  render() {
    return <div ref={this.widgetRef} />;
  }
}

export default TTPArticleWidget;



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Article/TTPArticleWidget.js